<template>
    <div v-if="$store.state.isModalOpenThree" class="modal fade show" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">{{ 'Add Project' }}</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">

                    <div class="col-11 py-1 mx-auto">
                        <div class="mb-1">
                            <label class="form-label" for="fullName"> <span class="required">*</span> Project Name</label>
                            <input
                                name="amount" @input="formError.name = ''"
                                type="text" v-model.trim="formData.name"
                                class="form-control"
                            />
                            <transition name="fade">
                                <span v-if="formError.name" class="invalid-feedback d-block qcont">{{ formError.name }}</span>
                            </transition>
                        </div>


                        <div class="d-flex justify-content-between">

                            <div class="mb-1 col-6">
                                <label class="form-label" for="gender"> Start Date</label>
                                <input type="date" class="form-control" v-model="formData.start_date">
                            </div>
                            <div class="mb-1 col-6">
                              <label class="form-label" for="gender"> End Date</label>
                              <input type="date" class="form-control" v-model="formData.end_date">
                            </div>
                        </div>

                      <div class="d-flex justify-content-between">

                        <div class="mb-1 col-12">
                          <label class="form-label" for="gender"> Party</label>
                          <v-select
                              placeholder="Select Party"
                              v-model="formData.party_id"
                              :options="parties"
                              label="name"
                              :reduce="name => name.id"
                          />
                        </div>
                      </div>

                    </div>

                    <div class="col-12 text-center">
                        <SubmitCancelBtn @on-submit="submit" @on-cancel="onClickClose"  :loading="loading"/>
                    </div>

                </div>
            </div>
        </div>
        <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import handleChartAccount from '@/services/modules/chartAccount'
import Loader from "@/components/atom/LoaderComponent";
import handleRole from "@/services/modules/role";
import handleHospital from "@/services/modules/hospital";
import { inject, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleCrm from "@/services/modules/crm/crm";
import handleContact from "@/services/modules/contact";
import SubmitCancelBtn from "@/components/atom/SubmitCancelBtn.vue";
import handleProjects from "@/services/modules/procurement/project";

const props = defineProps(['doctors', 'onCreateProject']);
const emit = defineEmits(['onCreateProject']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const {fetchHome} = handleChartAccount()
const {fetchCompanyDefaultRoles} = handleRole();
const {dateOfBarthConvertToAge} = handleHospital()
const {fetchAreaList} = handleCrm()
const {fetchContactProfiles} = handleContact()
const showError = inject('showError');
const showSuccess = inject('showSuccess');
let parties = ref([]);

let {
  fetchParties,
  createNewProject,
} = handleProjects();

const formData = reactive({
  name: null,
  date: null,
  start_date: null,
  end_date: null,
  party_id: null,
  interval:'one_off',
})

const formError = reactive({
  name: '',
})

//Functions and methods
const submit = async() => {
    if(checkValidation()) return;
    const query = getQuery();

    loading.value = true;

    await createNewProject(query, formData).then((res) => {
        loading.value = false
        if (!res.status) return showError(res.message)
        const resData = res.data;
        emit('onCreateProject', resData);
        onClickClose();
        showSuccess(res.message)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const checkValidation = () => {
    let flag = false;

    if(!formData.name){
        formError.name = 'Project name is required'
        flag = true;
    }

    return flag;
}

const onClickClose = () => {
    $store.state.isModalOpenThree = false;
}

function getQuery() {
  let query = `?company_id=${$route.params.companyId}`;
  query += `&from_project=1`

  return query;
}

onMounted(async () => {
  const query = getQuery();
  formData.date =  new Date().toISOString().split('T')[0]
  loader.value = true;
  const partyRes = fetchParties(query);
  await Promise.all([
    partyRes.then(res => {
      if (res.data) {
        parties.value = res.data;
      }
    }),
  ]).then(() => {
    loader.value = false
  }).catch((err) => {
    loader.value = false
  });

});

</script>
